import { CASE_STATES } from '@/api/resources/entityState/case-state'
import { GridUtils } from '@/shared/util/grid-utils'

const getFullTranslationKey = key => `component.studyRequest.sideBar.${key}`

export default {
    sideBarName: 'studySideBar',
    expanded: [
        { id: 'study',
            label: getFullTranslationKey('cases'),
            hasChildren: true,
            icon: ['fal', 'file-alt'],
            children: [
                { id: 'draftCases',
                    label: getFullTranslationKey('ongoing'),
                    icon: ['fal', 'spinner'],
                    filterModel: {
                        'status': GridUtils.getSetFilterModel([CASE_STATES.DRAFT.code])
                    }
                },
                {
                    id: 'registryDates',
                    label: getFullTranslationKey('registeredMasculine'),
                    hasChildren: true,
                    icon: ['fal', 'calendar-alt'],
                    children: [
                        {
                            id: 'registryToday',
                            label: getFullTranslationKey('today'),
                            filterModel: {
                                casRegistrationDate: GridUtils.getTodayDateFilterModel()
                            }
                        },
                        {
                            id: 'registryThisWeek',
                            label: getFullTranslationKey('thisWeek'),
                            filterModel: {
                                casRegistrationDate: GridUtils.getThisWeekDateFilterModel()
                            }
                        },
                        {
                            id: 'registryThisMonth',
                            label: getFullTranslationKey('thisMonth'),
                            filterModel: {
                                casRegistrationDate: GridUtils.getThisMonthDateFilterModel()
                            }
                        }
                    ]
                },
                { id: 'lastCases',
                    label: getFullTranslationKey('latestCases'),
                    icon: ['fal', 'clock'],
                    hasChildren: true,
                    noLock: true,
                    children: []
                }
            ]
        }
    ],
    module: {
        icon: ['fal', 'cabinet-filing'],
        name: 'global.register',
        subModule: 'global.register'
    }
}
